import T from 'i18n-react';
import clone from 'lodash/clone';
import { ITEM_TYPE } from 'views/DocumentManagement/components/FunctionBar/constants';

export const TAB_KEYS = {
  ALL_JOB: 'all_job',
  ARCHIVED: 'archived',
};
export const TAB_LABELS = {
  [TAB_KEYS.ALL_JOB]: 'All',
  [TAB_KEYS.ARCHIVED]: 'Archived',
};

export const TAB_STATUSES = {
  [TAB_KEYS.ALL_JOB]: 'active',
  [TAB_KEYS.ARCHIVED]: 'archived',
};
export const TAB_FUNCTION_ITEMS = {
  [TAB_KEYS.ALL_JOB]: [
    ITEM_TYPE.SELECT,
    ITEM_TYPE.SET_DATA,
    ITEM_TYPE.SET_DATES,
    ITEM_TYPE.ARCHIVE,
    ITEM_TYPE.DOWNLOAD,
    ITEM_TYPE.SHARE,
    ITEM_TYPE.RENAME,
    ITEM_TYPE.EDIT_TYPE,
    ITEM_TYPE.MOVE,
    ITEM_TYPE.REMOVE,
  ],
  [TAB_KEYS.ARCHIVED]: [
    ITEM_TYPE.SELECT,
    ITEM_TYPE.SET_DATA,
    ITEM_TYPE.SET_DATES,
    ITEM_TYPE.UN_ARCHIVE,
    ITEM_TYPE.DOWNLOAD,
    ITEM_TYPE.SHARE,
    ITEM_TYPE.RENAME,
    ITEM_TYPE.EDIT_TYPE,
    ITEM_TYPE.MOVE,
    ITEM_TYPE.REMOVE,
  ],
};
export const DEFAULT_FILTER_OBJ = {
  jobType: [],
  source: [],
  checked: [],
  uploadedDate: {
    field: ['createdAt'],
    method: ['az'],
    dates: [],
  },
};
export const DEFAULT_FILTERS = {
  [TAB_KEYS.ALL_JOB]: {
    ...clone(DEFAULT_FILTER_OBJ),
  },
  [TAB_KEYS.ARCHIVED]: {
    ...clone(DEFAULT_FILTER_OBJ),
  },
};
export const fieldItems = [
  {
    value: 'expiryDate',
    label: T.translate('documentManagement.text.Expiry Date'),
  },
  {
    value: 'reviewDate',
    label: T.translate('documentManagement.text.Review Date'),
  },
  {
    value: 'createdAt',
    label: T.translate('documentManagement.text.Uploaded Date'),
  },
];
export const methodItems = [
  {
    value: 'az',
    label: T.translate('general.newestToOldest'),
  },
  {
    value: 'za',
    label: T.translate('general.oldestToNewest'),
  },
];
export const sizeMethodItems = [
  {
    value: 'za',
    label: T.translate('documentManagement.filters.size.az'),
  },
  {
    value: 'az',
    label: T.translate('documentManagement.filters.size.za'),
  },
];
// productProfileDocuments
export const CHECKED_OPTIONS = [
  {
    value: 'underReview',
    label: T.translate('productProfileDocuments.checked.underReview'),
  },
  {
    value: 'accepted',
    label: T.translate('productProfileDocuments.checked.accepted'),
  },
  {
    value: 'rejected',
    label: T.translate('productProfileDocuments.checked.rejected'),
  },
  {
    value: 'notApplicable',
    label: T.translate('productProfileDocuments.checked.not-applicable'),
  },
];
